import React, { useEffect, useState } from "react";
import AdminServices from "../../../services/AdminServices";
import CashFlowSummaryCard from "./CashFlowSummaryCard";
import CashEntryPendingModal from "../CashBook/CashEntryPendingModal";

const getUserRole = () => {
  try {
    const user = JSON.parse(
      localStorage.getItem("userDetails")
    );

    return String(user?.data?.user?.role || "")
      .trim()
      .toLowerCase();
  } catch {
    return "";
  }
};

const getDashboardPayload = (response) =>
  response?.data?.data || response?.data || response || {};

const Home3 = ({ dashboardData }) => {
  const [showCashFlowModal, setShowCashFlowModal] =
    useState(false);

  const [userRole] = useState(getUserRole);
  const [cashDashboard, setCashDashboard] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const canViewCashFlow = [
    "cashmaker",
    "cashchecker",
    "accounts"
  ].includes(userRole);

  // Accounts receives the existing Home2 dashboard data.
  const hasParentData = dashboardData !== undefined;

  useEffect(() => {
    if (!canViewCashFlow || hasParentData) return;

    let active = true;

    setLoading(true);
    setError("");

    AdminServices.dashboard()
      .then((response) => {
        if (active) {
          setCashDashboard(getDashboardPayload(response));
        }
      })
      .catch(() => {
        if (active) {
          setError("Unable to load cash approval counts.");
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [canViewCashFlow, hasParentData, userRole]);

  if (!canViewCashFlow) return null;

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          {error && (
            <div className="alert alert-danger py-2">
              {error}
            </div>
          )}

          <CashFlowSummaryCard
            data={
              hasParentData ? dashboardData : cashDashboard
            }
            loading={loading}
            onClick={() => setShowCashFlowModal(true)}
          />
        </div>
      </div>

      <CashEntryPendingModal
        show={showCashFlowModal}
        handleClose={() => setShowCashFlowModal(false)}
        userRole={userRole}
      />
    </>
  );
};

export default Home3;